import {
	EnumsV1AnswerType,
	EnumsV1QuestionVisibility,
	type TypesV1CustomQuestionAnswer,
	type TypesV1CustomQuestionAnswerAnswer,
	type TypesV1CustomQuestionSettings,
} from '@sdk/Api'

export function isCustomQuestionVisible(visibility: EnumsV1QuestionVisibility): boolean {
	return visibility !== EnumsV1QuestionVisibility.QUESTION_VISIBILITY_HIDDEN
}

export function isCustomQuestionRequired(visibility: EnumsV1QuestionVisibility): boolean {
	return visibility === EnumsV1QuestionVisibility.QUESTION_VISIBILITY_REQUIRED
}

export function initCustomQuestionAnswersForm(customQuestions: TypesV1CustomQuestionSettings[]) {
	return customQuestions
		.filter((question) => isCustomQuestionVisible(question.visibility))
		.map<TypesV1CustomQuestionAnswer>((question) => {
			const answer: TypesV1CustomQuestionAnswerAnswer = question.basicQuestion
				? question.basicQuestion.answerType === EnumsV1AnswerType.ANSWER_TYPE_TEXT
					? { text: '' }
					: { checkbox: false }
				: { options: { values: [] } }

			return {
				question: question.question,
				answer,
			}
		})
}
